(function (window) {
  'use strict';

  var root = document.querySelector('[data-umbrella-configurator]');
  if (!root || !window.LEAVES_CONFIGURATOR_RULES || !window.LEAVES_CONFIGURATOR_CORE) return;

  // ─── Constants ──────────────────────────────────────────────────────────────

  var SCENE_INSTALL_ALLOWLIST = {
    umbrella: ['ceiling_hanging', 'ceiling_track', 'wrap_around'],
    tree: ['wrap_around', 'ceiling_track'],
    ceiling: ['ceiling_hanging', 'ceiling_track'],
    wall: ['wall_track', 'mounted_hanging', 'ceiling_track'],
    fence: ['mounted_hanging', 'wrap_around'],
    grass: ['floor_track', 'ground_spike'],
  };

  function readSceneId() {
    try {
      var params = new URLSearchParams(window.location.search || '');
      return String(params.get('scene') || '')
        .trim()
        .toLowerCase();
    } catch (err) {
      return '';
    }
  }

  function applySceneInstallFilter(baseRules, sceneId) {
    var allowed = SCENE_INSTALL_ALLOWLIST[sceneId];
    if (!allowed || !baseRules || !baseRules.installations) return baseRules;
    var byId = {};
    baseRules.installations.forEach(function (item) {
      byId[item.id] = item;
    });
    var installations = allowed
      .map(function (id) {
        return byId[id];
      })
      .filter(Boolean);
    return Object.assign({}, baseRules, {
      installations: installations,
      maxInstallations: baseRules.maxInstallations || 3,
    });
  }

  function readPresetId() {
    try {
      return String(new URLSearchParams(window.location.search || '').get('preset') || '').trim();
    } catch (err) {
      return '';
    }
  }

  // Preset cards use the full installation list. Scene links stay on the allowlist.
  var sceneId = readPresetId() ? '' : readSceneId();
  var rules = applySceneInstallFilter(window.LEAVES_CONFIGURATOR_RULES, sceneId);
  var core = window.LEAVES_CONFIGURATOR_CORE;
  var pricing = window.LEAVES_CONFIGURATOR_PRICING || null;
  var priceCatalog = pricing ? pricing.emptyCatalog() : null;
  if (priceCatalog) {
    priceCatalog.moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
  }
  var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
  var state = core.createState();
  if (sceneId) state.sceneId = sceneId;
  var currentStep = 1;
  var submitting = false;
  var submitWatchdog = null;
  var selectors = {
    installations: root.querySelector('[data-installation-options]'),
    lengths: root.querySelector('[data-line-options]'),
    modes: root.querySelector('[data-control-options]'),
    fixtures: root.querySelector('[data-fixture-options]'),
    fixtureMeter: root.querySelector('[data-fixture-meter]'),
    fixtureMeterCount: root.querySelector('[data-fixture-meter-count]'),
    fixtureMeterNote: root.querySelector('[data-fixture-meter-note]'),
    fixtureMeterFill: root.querySelector('[data-fixture-meter-fill]'),
    fixtureMeterCells: root.querySelector('[data-fixture-meter-cells]'),
    fixtureBranchNav: root.querySelector('[data-fixture-branch-nav]'),
    next: root.querySelector('[data-next]'),
    back: root.querySelector('[data-back]'),
    title: root.querySelector('[data-step-title]'),
    description: root.querySelector('[data-step-description]'),
    eyebrow: root.querySelector('[data-step-eyebrow]'),
    progress: root.querySelector('[data-progress-line]'),
    buildCount: root.querySelector('[data-build-count]'),
    buildList: root.querySelector('[data-build-list]'),
    buildFixtures: root.querySelector('[data-build-fixtures]'),
    buildFixtureCells: root.querySelector('[data-build-fixture-cells]'),
    buildFixtureMeter: root.querySelector('[data-build-fixture-meter]'),
    buildTotal: root.querySelector('[data-build-total]'),
    buildTotalAmount: root.querySelector('[data-build-total-amount]'),
    fixtureHeading: root.querySelector('[data-fixture-heading]'),
    fixtureHint: root.querySelector('[data-fixture-hint]'),
    headerBack: root.querySelector('[data-header-back]'),
    headerNext: root.querySelector('[data-header-next]'),
    step3: root.querySelector('[data-step="3"]'),
    buildCard: root.querySelector('.umbrella-configurator__build-card'),
    side: root.querySelector('.umbrella-configurator__side'),
    itemZoom: root.querySelector('[data-item-zoom]'),
  };
  var copy = {
    1: [
      'How will you mount light here?',
      'You are in a scene — pick up to 3 installation methods that fit this space. Cable length and fixtures come next.',
    ],
    2: ['How long should the cable be?', 'Pick colour and length for each installation separately.'],
    3: [
      'Set the atmosphere',
      'One light character for the whole kit — soft white calm, or colour that moves with the evening.',
    ],
    4: ['Make it yours.', 'Pick your lights — up to 6 lights in total for this kit.'],
  };
  var CDN = 'https://www.leaveslighting.com/cdn/shop/t/4/assets/';
  var FILES = 'https://cdn.shopify.com/s/files/1/0754/8328/3635/files/';
  var INSTALL_IMAGES = {
    wrap_around: FILES + 'Umbrella-Kit_8514492956851.jpg',
    suspended: CDN + 'dining-bell-pendants.jpg',
    mounted_hanging: CDN + 'scene-wall-spots.jpg',
    ceiling_hanging: CDN + 'scene-pergola-arizona.jpg',
    wall_track: CDN + 'scene-wall-spots.jpg',
    floor_track: CDN + 'garden-globes-ground.jpg',
    ceiling_track: CDN + 'scene-pergola-arizona.jpg',
    ground_spike: CDN + 'garden-globes-ground.jpg',
  };
  var INSTALL_BLURBS = {
    wrap_around: 'Patio perimeter & enclosure',
    suspended: 'Beam-mounted hanging',
    mounted_hanging: 'Wall hanging',
    ceiling_hanging: 'Ceiling hanging',
    wall_track: 'Wall track layout',
    floor_track: 'Floor track layout',
    ceiling_track: 'Ceiling track layout',
    ground_spike: 'Lawn & ground spike',
  };
  var fixtureBranchIndex = 0;
  var pendingBuildScrollKey = '';
  var editingCartKeys = [];
  var editingItemKey = '';
  var CONFIG_EDIT_STORAGE_PREFIX = 'leavesPatioConfig:';
  var cableImages = {};
  try {
    cableImages = JSON.parse(
      root.getAttribute('data-cable-images') || root.getAttribute('data-cable-videos') || '{}'
    );
  } catch (e) {
    cableImages = {};
  }
  try {
    var installImagesFromTheme = JSON.parse(root.getAttribute('data-install-images') || '{}');
    Object.keys(installImagesFromTheme).forEach(function (key) {
      var url = installImagesFromTheme[key];
      if (url) INSTALL_IMAGES[key] = url;
    });
  } catch (e2) {}
  var reduceMotion = false;
  try {
    reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}
  var wireObserver = null;
  if ('IntersectionObserver' in window) {
    wireObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!window.LeavesCableCard) return;
          window.LeavesCableCard.setPlaying(
            entry.target,
            entry.isIntersecting && currentStep === 2 && !reduceMotion
          );
        });
      },
      { threshold: 0.2 }
    );
  }

  // ─── State helpers ──────────────────────────────────────────────────────────

  function setState(next) {
    state = core.clone(next);
  }
  function esc(value) {
    return String(value).replace(/[&<>'"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[c];
    });
  }
  function error(selector, text) {
    var element = root.querySelector(selector);
    if (element) {
      element.textContent = text || '';
      element.hidden = !text;
      if (text) {
        try {
          element.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        } catch (scrollErr) {}
      }
    }
    // Mirror submit errors next to Confirm so failures are never silent.
    if (selector === '[data-submit-error]') {
      var side = root.querySelector('[data-submit-error-side]');
      if (side) {
        side.textContent = text || '';
        side.hidden = !text;
      }
    }
  }
  function splitButtonLabel(host, text, options) {
    if (!host) return;
    var value = String(text || '');
    var silent = options && options.silent;
    if (
      host.getAttribute('data-split-text') === value &&
      host.querySelector('.umbrella-configurator__primary-letters')
    ) {
      return;
    }
    host.setAttribute('data-split-text', value);
    host.textContent = '';
    var row = document.createElement('span');
    row.className = 'umbrella-configurator__primary-letters';
    row.setAttribute('aria-hidden', 'true');
    var button = host.closest('button');
    if (button && !silent) button.setAttribute('aria-label', value);
    Array.prototype.forEach.call(value.split(''), function (ch, index) {
      var unit = document.createElement('span');
      unit.className = 'umbrella-configurator__primary-char';
      unit.style.setProperty('--i', String(Math.min(index, 10)));
      var top = document.createElement('i');
      var bottom = document.createElement('i');
      var glyph = ch === ' ' ? '\u00a0' : ch;
      top.textContent = glyph;
      bottom.textContent = glyph;
      unit.appendChild(top);
      unit.appendChild(bottom);
      row.appendChild(unit);
    });
    host.appendChild(row);
  }
  function clearErrors() {
    Array.prototype.forEach.call(root.querySelectorAll('[role=alert]'), function (element) {
      element.hidden = true;
      element.textContent = '';
    });
  }
  function findBranch(branchId) {
    return state.installations.find(function (item) {
      return item.branchId === branchId;
    });
  }
  function updateBranch(branchId, changes) {
    setState(
      Object.assign({}, state, {
        installations: state.installations.map(function (item) {
          return item.branchId === branchId ? Object.assign({}, item, changes) : item;
        }),
      })
    );
  }
  function nextBranchId() {
    var max = 0;
    state.installations.forEach(function (item) {
      var match = String(item.branchId || '').match(/(\d+)$/);
      if (match) max = Math.max(max, Number(match[1]));
    });
    return 'branch-' + (max + 1);
  }
  function installationCount(id) {
    return state.installations.filter(function (item) {
      return item.installationId === id;
    }).length;
  }
  function branchTitle(branch) {
    var installation = core.getInstallation(rules, branch.installationId);
    var label = (installation && installation.label) || 'Installation';
    var total = installationCount(branch.installationId);
    if (total < 2) return label;
    var n = 0;
    var seen = 0;
    state.installations.forEach(function (item) {
      if (item.installationId !== branch.installationId) return;
      seen += 1;
      if (item.branchId === branch.branchId) n = seen;
    });
    return label + ' ' + n;
  }
  function button(label, selected, handler, detail) {
    var element = document.createElement('button');
    element.type = 'button';
    element.className = 'umbrella-configurator__option' + (selected ? ' is-selected' : '');
    element.setAttribute('aria-pressed', selected ? 'true' : 'false');
    element.innerHTML =
      '<strong>' + esc(label) + '</strong><small>' + esc(detail || '') + '</small>';
    element.addEventListener('click', handler);
    return element;
  }
  function iconSvg(kind) {
    if (kind === 'minus') {
      return '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"></path></svg>';
    }
    return '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"></path><path d="M12 5v14"></path></svg>';
  }
  function fixtureImage(fixtureOrSku) {
    if (fixtureOrSku && typeof fixtureOrSku === 'object') {
      if (fixtureOrSku.imageUrl) return fixtureOrSku.imageUrl;
      return fixtureImage(fixtureOrSku.sku || fixtureOrSku.id);
    }
    var s = String(fixtureOrSku || '').toUpperCase();
    if (s.indexOf('XMY') !== -1) return FILES + 'XMY-Pendant_8514492301491.jpg';
    if (s.indexOf('BJW') !== -1 || s.indexOf('XBJW') !== -1)
      return FILES + 'BellPendant-BLACK-XBJW_8514492203187.jpg';
    if (s.indexOf('SZ') !== -1) return CDN + 'spot-sz-pic.png';
    if (s.indexOf('RXXTD') !== -1 || s.indexOf('ZCHW') !== -1 || s.indexOf('G18') !== -1)
      return FILES + 'LED-Strip_8514492235955.jpg';
    if (s.indexOf('PC-D') !== -1 || s.indexOf('PC-VS') !== -1 || s.indexOf('-HS') !== -1)
      return CDN + 'lantern-round.jpg';
    if (s.indexOf('YQPC') !== -1) return CDN + 'globe-14w.png';
    return CDN + 'globe-md.jpg';
  }
  function normalizeSpecKey(value) {
    return String(value || '')
      .toUpperCase()
      .replace(/[（(][^）)]*[）)]/g, '')
      .replace(/[^A-Z0-9]+/g, '');
  }

  function lookupProductSpec(skuOrLabel) {
    var pack = window.LEAVES_PRODUCT_SPECS || {};
    var byModel = pack.byModel || pack;
    var byNorm = pack.byNorm || {};
    var raw = String(skuOrLabel || '').trim();
    if (!raw) return '';
    if (byModel[raw]) return byModel[raw];
    var key = normalizeSpecKey(raw);
    if (!key) return '';
    if (byNorm[key]) return byNorm[key];
    var best = '';
    Object.keys(byNorm).forEach(function (normKey) {
      if (!normKey) return;
      if (key.indexOf(normKey) !== -1 || normKey.indexOf(key) !== -1) {
        if (normKey.length > best.length) best = normKey;
      }
    });
    return best ? byNorm[best] : '';
  }

  /**
   * Spec sheet lines often only label Size:. Infer the rest so the popup
   * reads like Size: / Power: / CCT: … instead of bare values.
   */
  function parseSpecLine(line) {
    var raw = String(line || '').replace(/\s+/g, ' ').trim();
    if (!raw) return null;

    // 防水等级IP65 60° → label without colon in source data
    if (/^防水等级(?![:：])/.test(raw)) {
      return { label: '防水等级', value: raw.replace(/^防水等级\s*/, '') };
    }

    var labeled = raw.match(/^([A-Za-z][A-Za-z0-9 /+_-]{0,28}|[\u4e00-\u9fff]{1,12})\s*[:：]\s*(.+)$/);
    if (labeled) {
      return { label: labeled[1].trim(), value: labeled[2].trim() };
    }

    if (/^(Spot Light|Floor Type|Rail|Cut at set length)\b/i.test(raw)) {
      return { label: 'Type', value: raw };
    }
    if (/^\d+(\.\d+)?\s*W(\s|\/|$)/i.test(raw) || /^\d+(\.\d+)?\s*W\s*\/\s*Meter/i.test(raw)) {
      return { label: 'Power', value: raw };
    }
    if (/^\d{3,4}\s*K(-\d{3,4}\s*K)?(\b|$)/i.test(raw)) {
      return { label: 'CCT', value: raw };
    }
    if (/^(CRI|RA)\b/i.test(raw)) {
      return { label: 'CRI', value: raw };
    }
    if (/\b(Sanan|Osram|Chinese)\b/i.test(raw) || (/\bchip\b/i.test(raw) && /\bIP\d{2}/i.test(raw))) {
      return { label: 'LED / IP', value: raw };
    }
    if (/\b(Aluminum|Glass|PVC|silicone|Silicone|PC\+|\+PC|\bPC\b)/i.test(raw)) {
      return { label: 'Material', value: raw };
    }
    if (/\b(Black|White|Milky|Transparent|Matt)\b/i.test(raw)) {
      return { label: 'Color', value: raw };
    }
    if (/warranty|price for|unit price/i.test(raw)) {
      return { label: 'Note', value: raw };
    }
    if (/^IP\d{2}\b/i.test(raw)) {
      return { label: 'IP', value: raw };
    }
    if (/^DC\s*\d+V\b/i.test(raw)) {
      return { label: 'Voltage', value: raw };
    }

    return { label: '', value: raw };
  }

  function renderSpecLineItem(line) {
    var parts = parseSpecLine(line);
    if (!parts) return null;
    var item = document.createElement('li');
    if (parts.label) {
      item.innerHTML =
        '<span class="umbrella-configurator__fx-spec-label">' +
        esc(parts.label) +
        ':</span> ' +
        esc(parts.value);
    } else {
      item.textContent = parts.value;
    }
    return item;
  }

  function ensureSpecModal() {
    var modal = document.getElementById('leaves-fx-spec-modal');
    if (modal) return modal;
    modal = document.createElement('div');
    modal.id = 'leaves-fx-spec-modal';
    modal.className = 'umbrella-configurator__fx-spec-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'leaves-fx-spec-modal-title');
    if (typeof HTMLElement !== 'undefined' && typeof HTMLElement.prototype.showPopover === 'function') {
      // manual: we handle outside-click ourselves on the transparent overlay
      modal.setAttribute('popover', 'manual');
    } else {
      modal.hidden = true;
    }
    modal.innerHTML =
      '<div class="umbrella-configurator__fx-spec-modal-card">' +
      '<div class="umbrella-configurator__fx-spec-modal-head">' +
      '<strong id="leaves-fx-spec-modal-title" data-fx-spec-title></strong>' +
      '<button type="button" class="umbrella-configurator__fx-spec-modal-close" data-fx-spec-close aria-label="Close">×</button>' +
      '</div>' +
      '<div class="umbrella-configurator__fx-spec-modal-body" data-fx-spec-body></div>' +
      '</div>';
    document.body.appendChild(modal);

    function closeModal() {
      if (modal.matches && modal.matches(':popover-open') && modal.hidePopover) {
        try {
          modal.hidePopover();
        } catch (err) {
          /* ignore */
        }
      }
      modal.hidden = true;
      modal.classList.remove('is-open');
    }

    modal.querySelector('[data-fx-spec-close]').addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      closeModal();
    });
    // Click anywhere outside the white card (transparent overlay) closes the popup
    modal.addEventListener('pointerdown', function (event) {
      if (event.target === modal || !event.target.closest('.umbrella-configurator__fx-spec-modal-card')) {
        closeModal();
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (modal.classList.contains('is-open') || (modal.matches && modal.matches(':popover-open'))) {
        closeModal();
      }
    });
    return modal;
  }

  function openSpecModal(title, skuOrLabel) {
    var modal = ensureSpecModal();
    var titleEl = modal.querySelector('[data-fx-spec-title]');
    var bodyEl = modal.querySelector('[data-fx-spec-body]');
    titleEl.textContent = title || skuOrLabel || 'Details';
    bodyEl.innerHTML = '';
    var text = lookupProductSpec(skuOrLabel);
    if (text) {
      var list = document.createElement('ul');
      list.className = 'umbrella-configurator__fx-spec-modal-list';
      text.split('\n').forEach(function (line) {
        var item = renderSpecLineItem(line);
        if (item) list.appendChild(item);
      });
      bodyEl.appendChild(list);
    } else {
      var empty = document.createElement('p');
      empty.className = 'umbrella-configurator__fx-spec-modal-empty';
      empty.textContent = 'Detailed specs are not available for this item yet.';
      bodyEl.appendChild(empty);
    }
    modal.hidden = false;
    modal.classList.add('is-open');
    if (modal.showPopover) {
      try {
        if (!modal.matches(':popover-open')) modal.showPopover();
      } catch (err) {
        /* ignore */
      }
    }
  }

  function buildSpecDetailsControls(card, skuOrLabel) {
    var detailsBtn = document.createElement('button');
    detailsBtn.type = 'button';
    detailsBtn.className = 'btn btn-sm umbrella-configurator__fx-details-btn';
    detailsBtn.textContent = 'Details';
    detailsBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var title =
        (card.querySelector('h3') && card.querySelector('h3').textContent) ||
        skuOrLabel ||
        'Details';
      openSpecModal(title, skuOrLabel);
    });
    return { button: detailsBtn };
  }
  var fixturePick = {};
  var FIXTURE_FAMILIES = [
    { id: 'globe-pc', label: 'Globe Light', test: /YQPC/i },
    { id: 'globe-vr', label: 'Globe Light', test: /VR175/i },
    { id: 'globe-yq', label: 'Globe Light', test: /HW-YQ\d/i },
    { id: 'globe-mg', label: 'Globe Light', test: /HW-MG/i },
    { id: 'spot', label: 'Spot Pendant', test: /(?:^|-)SZ(?:-|$)/i },
    { id: 'xmy', label: 'XMY Pendant', test: /XMY/i },
    { id: 'bell', label: 'Bell Pendant', test: /BJW|XBJW/i, chips: 'color' },
    { id: 'strip', label: 'LED Linear Strip', test: /RXXTD|ZTSD|ZCHW|G18/i },
    { id: 'tube', label: 'Downlight', test: /(?:^|-)DT(?:-|$)/i },
    { id: 'lantern-hs', label: 'Decorative Lantern', test: /HS(?:SJZ|F|C|B)/i, chips: 'shape' },
    { id: 'lantern-pc', label: 'Decorative Lantern', test: /PC-(?:D|VS)/i },
  ];
  function skuWatt(sku) {
    var match = String(sku).match(/(\d+(?:\.\d+)?)W/i);
    return match ? match[1] + 'W' : '';
  }
  function fixtureChipLabel(sku, family) {
    var s = String(sku);
    var watt = skuWatt(s);
    if (family.chips === 'color') {
      var color = /(?:BJW|XBJW|HSSJZ|HSF|HSC|HSB)-W(?:-|$)/i.test(s) ? 'White' : 'Black';
      return watt && color === 'Black' && /-\d/.test(s) ? color + ' · ' + watt : color;
    }
    if (family.chips === 'shape') {
      if (/HSSJZ/i.test(s) || /HSB/i.test(s)) return 'Bell';
      if (/HSF/i.test(s)) return 'Square';
      if (/HSC/i.test(s)) return 'Round';
    }
    var size =
      (s.match(/PC-D(\d+)/i) ||
        s.match(/PC-VS(\d+)/i) ||
        s.match(/YQPC(\d+)/i) ||
        s.match(/YQ(\d+)/i) ||
        s.match(/MG(\d+)/i) ||
        s.match(/VR175-(\d+)/i) ||
        [])[1] || '';
    if (size) {
      var unit = /YQPC|YQ\d|MG\d/.test(s) ? 'cm' : 'mm';
      return size + unit + (watt ? ' · ' + watt : '');
    }
    return watt || s;
  }
  function familyForSku(sku) {
    var i;
    for (i = 0; i < FIXTURE_FAMILIES.length; i += 1) {
      if (FIXTURE_FAMILIES[i].test.test(sku)) return FIXTURE_FAMILIES[i];
    }
    return { id: 'sku-' + sku, label: sku, test: /$^/ };
  }
  function groupFixtureFamilies(fixtures) {
    var groups = [];
    var index = {};
    fixtures.forEach(function (fixture) {
      var family = familyForSku(fixture.sku || fixture.id);
      if (!index[family.id]) {
        index[family.id] = {
          id: family.id,
          label: family.label,
          chips: family.chips,
          items: [],
        };
        groups.push(index[family.id]);
      }
      index[family.id].items.push(fixture);
    });
    return groups;
  }
  // ─── Step 1 – Installation rendering ────────────────────────────────────────

  function addInstallation(installation) {
    if (state.installations.length >= rules.maxInstallations) {
      error(
        '[data-installation-error]',
        'You can select up to ' + rules.maxInstallations + ' installation lines.'
      );
      return;
    }
    var clear = root.querySelector('[data-installation-error]');
    if (clear && clear.textContent.indexOf('You can select up to') === 0) {
      clear.hidden = true;
      clear.textContent = '';
    }
    var installations = state.installations.concat({
      installationId: installation.id,
      branchId: nextBranchId(),
      lengthMeters: 7,
      shapeId: '',
      colorId: 'black',
      fixtures: {},
    });
    setState(
      Object.assign({}, state, {
        installations: installations,
        splitter: rules.splittersByBranchCount[installations.length] || null,
      })
    );
    clampFixtureBranch();
    renderAll();
  }
  function removeInstallation(installation) {
    var index = -1;
    state.installations.forEach(function (item, i) {
      if (item.installationId === installation.id) index = i;
    });
    if (index < 0) return;
    var installations = state.installations.slice();
    installations.splice(index, 1);
    setState(
      Object.assign({}, state, {
        installations: installations,
        splitter: rules.splittersByBranchCount[installations.length] || null,
      })
    );
    clampFixtureBranch();
    renderAll();
  }
  function renderInstallations() {
    selectors.installations.innerHTML = '';
    var atMax = state.installations.length >= rules.maxInstallations;
    rules.installations.forEach(function (installation) {
      var quantity = installationCount(installation.id);
      var card = document.createElement('article');
      card.className =
        'umbrella-configurator__installation-card' + (quantity ? ' is-selected' : '');
      card.dataset.installationId = installation.id;
      card.setAttribute('aria-pressed', quantity ? 'true' : 'false');
      card.addEventListener('click', function (event) {
        if (event.target.closest('button')) return;
        addInstallation(installation);
      });
      var media = document.createElement('div');
      media.className = 'umbrella-configurator__installation-media';
      media.dataset.imageSlot = 'installation-' + installation.id;
      var img = document.createElement('img');
      img.src = INSTALL_IMAGES[installation.id] || CDN + 'scene-pergola-arizona.jpg';
      img.alt = installation.label;
      img.loading = 'lazy';
      img.decoding = 'async';
      media.appendChild(img);
      var body = document.createElement('div');
      body.className = 'umbrella-configurator__installation-body';
      body.innerHTML =
        '<strong>' +
        esc(installation.label) +
        '</strong><small>' +
        esc(INSTALL_BLURBS[installation.id] || installation.label) +
        '</small>';
      var foot = document.createElement('div');
      foot.className = 'umbrella-configurator__install-foot';
      if (!quantity) {
        var add = document.createElement('button');
        add.type = 'button';
        add.className = 'btn btn-sm btn-primary';
        add.textContent = 'Add';
        if (atMax) {
          add.disabled = true;
          add.title = 'You can select up to ' + rules.maxInstallations + ' installation lines.';
        }
        add.addEventListener('click', function () {
          addInstallation(installation);
        });
        foot.appendChild(add);
      } else {
        var stepper = document.createElement('div');
        stepper.className = 'umbrella-configurator__qty-stepper';
        var minus = document.createElement('button');
        minus.type = 'button';
        minus.setAttribute('aria-label', 'Remove one ' + installation.label);
        minus.innerHTML = iconSvg('minus');
        var count = document.createElement('span');
        count.textContent = String(quantity);
        var plus = document.createElement('button');
        plus.type = 'button';
        plus.setAttribute('aria-label', 'Add another ' + installation.label);
        plus.innerHTML = iconSvg('plus');
        if (atMax) {
          plus.disabled = true;
          plus.title = 'You can select up to ' + rules.maxInstallations + ' installation lines.';
        }
        minus.addEventListener('click', function () {
          removeInstallation(installation);
        });
        plus.addEventListener('click', function () {
          addInstallation(installation);
        });
        stepper.appendChild(minus);
        stepper.appendChild(count);
        stepper.appendChild(plus);
        foot.appendChild(stepper);
      }
      body.appendChild(foot);
      card.appendChild(media);
      card.appendChild(body);
      selectors.installations.appendChild(card);
    });
  }
  function colorHex(id) {
    return { black: '#171717', blue: '#2f62c4', yellow: '#e0b125', green: '#2f7a43' }[id] || '#888';
  }
  function colorLabel(id) {
    var color = rules.colors.find(function (item) {
      return item.id === id;
    });
    return color ? color.label : 'No colour selected';
  }
  function colorShort(id) {
    return { black: 'Black', blue: 'Blue', yellow: 'Yellow', green: 'Green' }[id] || colorLabel(id);
  }
  function branchFixtureCount(branch) {
    if (!branch || !branch.fixtures) return 0;
    return Object.keys(branch.fixtures).reduce(function (sum, id) {
      return sum + Number(branch.fixtures[id] || 0);
    }, 0);
  }
  function clampFixtureBranch() {
    if (!state.installations.length) {
      fixtureBranchIndex = 0;
      return;
    }
    if (fixtureBranchIndex > state.installations.length - 1) {
      fixtureBranchIndex = state.installations.length - 1;
    }
    if (fixtureBranchIndex < 0) fixtureBranchIndex = 0;
  }
  function defaultCableMeters() {
    var allowed =
      rules.minLengthMeters <= 7 && rules.maxLengthMeters >= 7 ? 7 : rules.minLengthMeters;
    return allowed;
  }
  function formatLength(meters) {
    if (!meters) return '';
    return Number(meters) + ' m';
  }
  function ensureDefaultLengths() {
    var fallback = defaultCableMeters();
    var changed = false;
    var next = state.installations.map(function (branch) {
      if (Number(branch.lengthMeters)) return branch;
      changed = true;
      return Object.assign({}, branch, { lengthMeters: fallback });
    });
    if (changed) {
      state = Object.assign({}, state, { installations: next });
    }
  }
  function ensureDefaultColors() {
    var changed = false;
    var next = state.installations.map(function (branch) {
      if (branch.colorId) return branch;
      changed = true;
      return Object.assign({}, branch, { colorId: 'black' });
    });
    if (changed) {
      state = Object.assign({}, state, { installations: next });
    }
  }
  function setBranchLength(id, value, lengths) {
    var next = Number(value);
    if (
      !lengths.some(function (item) {
        return item === next;
      })
    )
      return;
    updateBranch(id, { lengthMeters: next });
    if (currentStep === 2 && syncWireLine(id)) {
      renderBuildCard();
      return;
    }
    renderAll();
  }
  function setBranchColor(id, colorId) {
    updateBranch(id, { colorId: colorId });
    if (currentStep === 2 && syncWireLine(id)) {
      renderBuildCard();
      return;
    }
    renderAll();
  }
  function lineFill(branch, installation) {
    var lengths = installation.allowedLengths;
    var min = lengths[0];
    var max = lengths[lengths.length - 1];
    var current = Number(branch.lengthMeters);
    if (!current) return 0;
    return ((current - min) / (max - min || 1)) * 100;
  }
  function cableUnitPriceText(branch) {
    // Safety: only Shopify catalog /products/{handle}.js prices — never invent or trust URL/input.
    if (!pricing || !priceCatalog || !branch) return '';
    var meters = Number(branch.lengthMeters);
    if (!branch.colorId || !meters) return '';
    var cable = core.getCable(rules, branch.colorId, meters);
    if (!cable) return '';
    var resolved = pricing.resolveCatalogEntry(cable, priceCatalog);
    if (resolved && resolved.priceCents != null) {
      return pricing.formatMoney(resolved.priceCents, priceCatalog.moneyFormat);
    }
    if (priceCatalog.loaded) return '—';
    return '…';
  }
  function syncWireLine(id) {
    var wrapper = selectors.lengths.querySelector('[data-branch-id="' + id + '"]');
    var branch = findBranch(id);
    if (!wrapper || !branch) return false;
    var installation = core.getInstallation(rules, branch.installationId);
    var lengths = installation.allowedLengths;
    var current = Number(branch.lengthMeters) || null;
    var fill = lineFill(branch, installation);
    wrapper.style.setProperty('--cable', branch.colorId ? colorHex(branch.colorId) : '#c8c8c8');
    wrapper.style.setProperty('--fill', String(Math.round(fill)));
    wrapper.dataset.color = branch.colorId || '';
    var num = wrapper.querySelector('[data-readout-num]');
    if (num) num.textContent = current ? String(current) : '—';
    var measure = wrapper.querySelector('.umbrella-configurator__line-measure');
    var priceEl = wrapper.querySelector('[data-cable-price]');
    if (!priceEl && measure) {
      priceEl = document.createElement('em');
      priceEl.className = 'umbrella-configurator__cable-price';
      priceEl.setAttribute('data-cable-price', '');
      measure.appendChild(priceEl);
    }
    if (priceEl) {
      var money = cableUnitPriceText(branch);
      priceEl.textContent = money || '';
      priceEl.hidden = !money;
    }
    Array.prototype.forEach.call(
      wrapper.querySelectorAll('.umbrella-configurator__swatch'),
      function (swatch) {
        var on = swatch.dataset.colorId === branch.colorId;
        swatch.classList.toggle('is-selected', on);
        swatch.setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    );
    Array.prototype.forEach.call(
      wrapper.querySelectorAll('.umbrella-configurator__len-opts button'),
      function (btn) {
        var on = current === Number(btn.dataset.meters);
        btn.classList.toggle('is-selected', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    );
    var slider = wrapper.querySelector('input[type="range"]');
    if (slider) slider.value = String(current || lengths[0]);
    var caption = wrapper.querySelector('[data-cable-caption]');
    if (caption) {
      caption.textContent = current
        ? 'Silicone cable unspooling. Current length: ' + formatLength(current) + '.'
        : 'Pick a colour and length — the cable unspools from the reel.';
    }
    if (window.LeavesCableCard) {
      window.LeavesCableCard.update(wrapper.querySelector('.umbrella-configurator__line-stage'), {
        length: fill / 100,
        colorId: branch.colorId || 'black',
        images: cableImages,
      });
    }
    return true;
  }
  // ─── Step 2 – Cable length & colour rendering ────────────────────────────────

  function renderLengthsAndColors() {
    if (currentStep !== 2) return;
    ensureDefaultLengths();
    ensureDefaultColors();
    selectors.lengths.dataset.count = String(state.installations.length || 0);
    var keep = {};
    state.installations.forEach(function (branch) {
      keep[branch.branchId] = true;
    });
    Array.prototype.forEach.call(
      Array.prototype.slice.call(selectors.lengths.children),
      function (el) {
        if (!keep[el.dataset.branchId]) {
          var oldStage = el.querySelector('.umbrella-configurator__line-stage');
          if (wireObserver && oldStage) wireObserver.unobserve(oldStage);
          if (window.LeavesCableCard && oldStage) window.LeavesCableCard.destroy(oldStage);
          el.remove();
        }
      }
    );
    state.installations.forEach(function (branch, index) {
      var existing = selectors.lengths.querySelector('[data-branch-id="' + branch.branchId + '"]');
      if (existing) {
        existing.style.setProperty('--delay', index * 90 + 'ms');
        var existingTitle = existing.querySelector('.umbrella-configurator__line-head h3');
        if (existingTitle) existingTitle.textContent = branchTitle(branch);
        var existingHead = existing.querySelector('.umbrella-configurator__line-head');
        var existingColors = existing.querySelector('.umbrella-configurator__swatches');
        if (existingHead && existingColors && existingColors.parentElement !== existingHead) {
          existingHead.appendChild(existingColors);
        }
        syncWireLine(branch.branchId);
        return;
      }
      var installation = core.getInstallation(rules, branch.installationId);
      var lengths = installation.allowedLengths;
      var min = lengths[0];
      var max = lengths[lengths.length - 1];
      var current = Number(branch.lengthMeters) || null;
      var wrapper = document.createElement('article');
      wrapper.className = 'umbrella-configurator__line';
      wrapper.dataset.branchId = branch.branchId;
      wrapper.dataset.installationId = branch.installationId;
      wrapper.style.setProperty('--delay', index * 90 + 'ms');

      var stage = document.createElement('div');
      stage.className = 'umbrella-configurator__line-stage';
      var title = document.createElement('h4');
      title.className = 'umbrella-configurator__oryzo-title';
      title.innerHTML = 'Cable<br>Length';
      var caption = document.createElement('p');
      caption.className = 'umbrella-configurator__oryzo-desc';
      caption.setAttribute('data-cable-caption', '');
      caption.textContent = 'Pick a colour and length — the cable unspools from the reel.';
      stage.appendChild(title);
      stage.appendChild(caption);
      if (window.LeavesCableCard) {
        window.LeavesCableCard.mount(stage, {
          length: current ? lineFill(branch, installation) / 100 : 0,
          colorId: branch.colorId || 'black',
          images: cableImages,
          reducedMotion: reduceMotion,
        });
      }
      if (wireObserver) wireObserver.observe(stage);

      var head = document.createElement('div');
      head.className = 'umbrella-configurator__line-head';
      var heading = document.createElement('h3');
      heading.textContent = branchTitle(branch);
      var colors = document.createElement('div');
      colors.className = 'umbrella-configurator__swatches';
      colors.setAttribute('role', 'group');
      colors.setAttribute('aria-label', installation.label + ' colour');
      rules.colors.forEach(function (item) {
        var swatch = document.createElement('button');
        swatch.type = 'button';
        swatch.className = 'umbrella-configurator__swatch';
        swatch.dataset.colorId = item.id;
        swatch.style.setProperty('--swatch', colorHex(item.id));
        swatch.setAttribute('aria-label', item.value || item.label);
        swatch.innerHTML = '<i></i><span>' + esc(colorShort(item.id)) + '</span>';
        swatch.addEventListener('click', function () {
          setBranchColor(branch.branchId, item.id);
        });
        colors.appendChild(swatch);
      });
      head.appendChild(heading);
      head.appendChild(colors);

      var measure = document.createElement('div');
      measure.className = 'umbrella-configurator__line-measure';
      var readout = document.createElement('p');
      readout.className = 'umbrella-configurator__length-readout';
      readout.innerHTML =
        '<b data-readout-num>' + (current ? current : defaultCableMeters()) + '</b><span>m</span>';
      var priceEl = document.createElement('em');
      priceEl.className = 'umbrella-configurator__cable-price';
      priceEl.setAttribute('data-cable-price', '');
      priceEl.textContent = cableUnitPriceText(branch) || '';
      priceEl.hidden = !priceEl.textContent;
      measure.appendChild(readout);
      measure.appendChild(priceEl);

      var sliderCol = document.createElement('div');
      sliderCol.className = 'umbrella-configurator__line-slider';
      var slider = document.createElement('input');
      slider.type = 'range';
      slider.className = 'cfg-range';
      slider.min = String(min);
      slider.max = String(max);
      slider.step = '1';
      slider.value = String(current || defaultCableMeters());
      slider.setAttribute('aria-label', installation.label + ' cable length');
      slider.addEventListener('input', function () {
        setBranchLength(branch.branchId, slider.value, lengths);
      });
      var ticks = document.createElement('div');
      ticks.className = 'umbrella-configurator__line-ticks';
      ticks.innerHTML =
        '<span>' + formatLength(min) + '</span><span>' + formatLength(max) + '</span>';
      sliderCol.appendChild(slider);
      sliderCol.appendChild(ticks);

      var picker = document.createElement('div');
      picker.className = 'umbrella-configurator__line-picker';
      picker.appendChild(measure);
      picker.appendChild(sliderCol);

      var cable = document.createElement('div');
      cable.className = 'umbrella-configurator__cable';
      cable.setAttribute('aria-hidden', 'true');

      var body = document.createElement('div');
      body.className = 'umbrella-configurator__line-body';
      body.appendChild(head);
      body.appendChild(picker);
      body.appendChild(cable);

      wrapper.appendChild(stage);
      wrapper.appendChild(body);
      selectors.lengths.appendChild(wrapper);
      syncWireLine(branch.branchId);
    });
  }
  function mixRgbArr(a, b, t) {
    return [
      Math.round(a[0] + (b[0] - a[0]) * t),
      Math.round(a[1] + (b[1] - a[1]) * t),
      Math.round(a[2] + (b[2] - a[2]) * t),
    ];
  }
  var RGB_SPECTRUM = [
    [0, [185, 212, 255]],
    [0.1667, [247, 248, 255]],
    [0.3333, [255, 154, 60]],
    [0.3333, [255, 51, 72]],
    [0.5556, [255, 216, 74]],
    [0.7778, [46, 211, 106]],
    [1, [58, 120, 255]],
  ];
  function sampleSpectrum(t) {
    t = Math.max(0, Math.min(1, Number(t) || 0));
    var i = 1;
    while (i < RGB_SPECTRUM.length && t > RGB_SPECTRUM[i][0]) i += 1;
    var from = RGB_SPECTRUM[i - 1];
    var to = RGB_SPECTRUM[Math.min(i, RGB_SPECTRUM.length - 1)];
    var span = to[0] - from[0];
    var u = span ? (t - from[0]) / span : 0;
    return mixRgbArr(from[1], to[1], u);
  }
  function stopLampRgbCycle(card) {
    if (card._lampRgbCycle) {
      cancelAnimationFrame(card._lampRgbCycle);
      card._lampRgbCycle = 0;
    }
  }
  function startLampRgbCycle(card) {
    stopLampRgbCycle(card);
    if (reduceMotion) {
      freezeLampRgb(card);
      return;
    }
    function tick() {
      if (card.classList.contains('is-hue-set')) {
        card._lampRgbCycle = 0;
        return;
      }
      syncLampColor(card);
      card._lampRgbCycle = requestAnimationFrame(tick);
    }
    card._lampRgbCycle = requestAnimationFrame(tick);
  }
  function lampRgbT(card) {
    if (!card.classList.contains('is-hue-set')) {
      var live = Number(getComputedStyle(card).getPropertyValue('--lamp-rgb-t-live'));
      if (!isNaN(live)) return live;
    }
    var inline = card.style.getPropertyValue('--lamp-rgb-t');
    if (inline !== '') return Number(inline);
    var computed = Number(getComputedStyle(card).getPropertyValue('--lamp-rgb-t'));
    return isNaN(computed) ? 0.5 : computed;
  }
  function lampCctValue(card) {
    var inline = card.style.getPropertyValue('--lamp-cct');
    if (inline !== '') return Number(inline);
    return 0.5;
  }
  var LAMP_WARM = [255, 132, 28];
  var LAMP_COOL = [70, 160, 255];
  function rgbCss(arr) {
    return 'rgb(' + arr[0] + ', ' + arr[1] + ', ' + arr[2] + ')';
  }
  function syncLampColor(card) {
    var base = sampleSpectrum(lampRgbT(card));
    var cct = lampCctValue(card);
    var amount = Math.abs(cct - 0.5) * 2;
    var mixed = base;
    // Keep the chosen colour recognisable on the globe; the room wash carries most
    // of the warm/cool shift. A full lerp turns blue into mud.
    if (cct < 0.5) mixed = mixRgbArr(base, LAMP_WARM, amount * 0.4);
    else if (cct > 0.5) mixed = mixRgbArr(base, LAMP_COOL, amount * 0.34);
    var color = rgbCss(mixed);
    card.style.setProperty('--lamp-glass', color);
    card.style.setProperty('--lamp-rgb', color);
    card.style.setProperty('--lamp-cct-color', rgbCss(cct < 0.5 ? LAMP_WARM : LAMP_COOL));
  }
  function freezeLampRgb(card) {
    if (card.classList.contains('is-hue-set')) return;
    var t = lampRgbT(card);
    card.style.setProperty('--lamp-rgb-t', Number(t).toFixed(4));
    card.style.setProperty('--lamp-rgb-t-shown', Number(t).toFixed(4));
    stopLampRgbCycle(card);
    card.classList.add('is-hue-set');
    syncLampColor(card);
  }
  function lampLevelValue(card) {
    if (!card.classList.contains('is-level-set')) {
      var live = Number(getComputedStyle(card).getPropertyValue('--lamp-level-live'));
      if (!isNaN(live)) return live;
    }
    var inline = card.style.getPropertyValue('--lamp-level');
    if (inline !== '') return Number(inline);
    var computed = Number(getComputedStyle(card).getPropertyValue('--lamp-level'));
    return isNaN(computed) ? 0.5 : computed;
  }
  function freezeLampLevel(card) {
    if (card.classList.contains('is-level-set')) return;
    var t = lampLevelValue(card);
    card.style.setProperty('--lamp-level', Number(t).toFixed(4));
    card.style.setProperty('--lamp-level-shown', Number(t).toFixed(4));
    card.classList.add('is-level-set');
  }
  function applyLampCct(card, strip, t) {
    var dist = Math.abs(t - 0.5) * 2;
    card.style.setProperty('--lamp-cct', t.toFixed(3));
    card.style.setProperty('--lamp-cct-mix', dist.toFixed(3));
    syncLampColor(card);
    card.classList.add('is-cct-set');
    strip.setAttribute('aria-valuenow', String(Math.round(t * 100)));
  }
  function bindLampStrip(card) {
    var strips = card.querySelectorAll('[data-lamp-strip]');
    if (!strips.length) return;

    function freezeTilt() {
      card.style.setProperty('--lamp-px', '0');
      card.style.setProperty('--lamp-py', '0');
    }

    var guard = card.querySelector('[data-lamp-guard]');
    function blockSelect(event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (guard) {
      guard.addEventListener('pointerdown', blockSelect);
      guard.addEventListener('pointerup', blockSelect);
      guard.addEventListener('click', blockSelect);
    }

    Array.prototype.forEach.call(strips, function (strip) {
      var kind = strip.getAttribute('data-lamp-strip');
      var dragging = false;

      function apply(event) {
        var box = strip.getBoundingClientRect();
        if (!box.width) return;
        var t = (event.clientX - box.left) / box.width;
        t = Math.max(0, Math.min(1, t));
        if (kind === 'level') {
          freezeLampLevel(card);
          card.style.setProperty('--lamp-level', t.toFixed(3));
          card.style.setProperty('--lamp-level-shown', t.toFixed(3));
          strip.setAttribute('aria-valuenow', String(Math.round(t * 100)));
        } else if (kind === 'cct') {
          applyLampCct(card, strip, t);
        } else {
          freezeLampRgb(card);
          card.style.setProperty('--lamp-rgb-t', t.toFixed(3));
          card.style.setProperty('--lamp-rgb-t-shown', t.toFixed(3));
          syncLampColor(card);
          strip.setAttribute('aria-valuenow', String(Math.round(t * 100)));
        }
      }

      function stopDrag() {
        if (!dragging) return;
        dragging = false;
        card.classList.remove('is-tuned', 'is-scrubbing', 'is-cct-scrub');
      }

      strip.addEventListener('pointerenter', function (event) {
        event.stopPropagation();
        card.classList.add('is-strip-hover');
        freezeTilt();
      });
      strip.addEventListener('pointerleave', function () {
        if (!dragging) card.classList.remove('is-strip-hover');
      });
      strip.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        event.preventDefault();
        event.stopPropagation();
        if (kind === 'hue') freezeLampRgb(card);
        if (kind === 'level') freezeLampLevel(card);
        dragging = true;
        card.classList.add('is-tuned', 'is-scrubbing', 'is-strip-hover');
        if (kind === 'cct') card.classList.add('is-cct-scrub');
        freezeTilt();
        try {
          if (strip.setPointerCapture) strip.setPointerCapture(event.pointerId);
        } catch (err) {}
        apply(event);
      });
      strip.addEventListener('pointermove', function (event) {
        event.stopPropagation();
        freezeTilt();
        if (!dragging) return;
        apply(event);
      });
      strip.addEventListener('pointerup', function (event) {
        event.preventDefault();
        event.stopPropagation();
        stopDrag();
      });
      strip.addEventListener('pointercancel', function (event) {
        event.stopPropagation();
        stopDrag();
      });
      strip.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
      });
    });
    if (card.querySelector('[data-lamp-strip="hue"]')) {
      startLampRgbCycle(card);
    }
    if (card.querySelector('[data-lamp-strip="level"]') && reduceMotion) {
      freezeLampLevel(card);
    }
  }
  function bindLampPointer(card) {
    if (reduceMotion) return;
    function setFromEvent(event) {
      if (card.classList.contains('is-scrubbing') || card.classList.contains('is-strip-hover')) {
        card.style.setProperty('--lamp-px', '0');
        card.style.setProperty('--lamp-py', '0');
        return;
      }
      var box = card.getBoundingClientRect();
      if (!box.width || !box.height) return;
      var x = (event.clientX - box.left) / box.width - 0.5;
      var y = (event.clientY - box.top) / box.height - 0.5;
      card.style.setProperty('--lamp-px', (x * 2).toFixed(3));
      card.style.setProperty('--lamp-py', (y * 2).toFixed(3));
    }
    card.addEventListener('pointerenter', function (event) {
      card.classList.add('is-hot');
      setFromEvent(event);
    });
    card.addEventListener('pointermove', setFromEvent);
    card.addEventListener('pointerleave', function () {
      card.classList.remove('is-hot');
      card.style.setProperty('--lamp-px', '0');
      card.style.setProperty('--lamp-py', '0');
    });
  }
  // ─── Step 3 – Lighting mode (lamp card) rendering ───────────────────────────

  function renderModes() {
    selectors.modes.innerHTML = '';
    selectors.modes.classList.toggle('is-compact', false);
    var intro = document.createElement('div');
    intro.className = 'umbrella-configurator__lamp-intro';
    intro.innerHTML =
      '<p class="umbrella-configurator__lamp-intro-kicker">How to choose</p>' +
      '<p class="umbrella-configurator__lamp-intro-lead">Try both.<br>Keep one.</p>' +
      '<p class="umbrella-configurator__lamp-intro-copy">Slide the controls below. When the mood settles, tap the upper area to continue.</p>';
    selectors.modes.appendChild(intro);
    rules.lightingModes.forEach(function (mode) {
      var selected = state.lightingMode === mode.id;
      var label = mode.id === 'cw' ? 'Basic model' : 'Vibrant Color model';
      var card = document.createElement('div');
      card.className =
        'umbrella-configurator__option umbrella-configurator__segment-item umbrella-configurator__lamp-card' +
        (selected ? ' is-selected' : '');
      card.dataset.imageSlot = 'mode-' + mode.id;
      card.setAttribute('role', 'group');
      card.setAttribute('aria-label', label);
      var stage = document.createElement('span');
      stage.className = 'umbrella-configurator__lamp-stage';
      stage.innerHTML = (window.LeavesLampCard && window.LeavesLampCard.markup(mode.id)) || '';
      var choose = document.createElement('button');
      choose.type = 'button';
      choose.className = 'umbrella-configurator__lamp-choose';
      choose.setAttribute('data-lamp-choose', '');
      choose.setAttribute('aria-pressed', selected ? 'true' : 'false');
      choose.setAttribute('aria-label', 'Continue with ' + label);
      stage.appendChild(choose);
      var strong = document.createElement('strong');
      strong.textContent = label;
      var small = document.createElement('small');
      small.textContent = mode.id === 'cw' ? 'Dim only · CW' : 'Color + temperature + dim · RGBCW';
      card.appendChild(stage);
      card.appendChild(strong);
      card.appendChild(small);
      choose.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        fixtureBranchIndex = 0;
        setState(
          Object.assign({}, state, {
            lightingMode: mode.id,
            installations: state.installations.map(function (branch) {
              return Object.assign({}, branch, {
                shapeId: mode.id === 'cw' ? 'basic' : 'vibrant',
                fixtures: {},
              });
            }),
          })
        );
        if (currentStep === 3) currentStep = 4;
        renderAll();
      });
      bindLampPointer(card);
      bindLampStrip(card);
      selectors.modes.appendChild(card);
    });
  }
  function fixtureUnitPriceText(fixture) {
    if (pricing && priceCatalog) {
      var resolved = pricing.resolveCatalogEntry(fixture, priceCatalog);
      if (resolved && resolved.priceCents != null) {
        return pricing.formatMoney(resolved.priceCents, priceCatalog.moneyFormat);
      }
    }
    if (fixture && fixture.priceSnapshot != null && fixture.priceSnapshot !== '') {
      var snap = Number(fixture.priceSnapshot);
      if (Number.isFinite(snap) && pricing) {
        return pricing.formatMoney(Math.round(snap * 100), (priceCatalog && priceCatalog.moneyFormat) || root.getAttribute('data-money-format'));
      }
      return String(fixture.priceSnapshot);
    }
    if (priceCatalog && priceCatalog.loaded) return '—';
    return '';
  }
  function formatSlotCount(value) {
    var n = roundFixtureSlots(value);
    return Number.isInteger(n) ? String(n) : n.toFixed(1);
  }

  function paintSlotCells(nodeList, filled) {
    var slots = roundFixtureSlots(filled);
    Array.prototype.forEach.call(nodeList, function (cell, index) {
      var full = index + 1 <= slots + 1e-9;
      var half = !full && index + 0.5 <= slots + 1e-9;
      cell.classList.toggle('is-filled', full);
      cell.classList.toggle('is-half', half);
    });
  }

  function updateFixtureMeter() {
    var meter = selectors.fixtureMeter;
    if (!meter) return;
    var maxTotal = Number(rules.maxTotalFixtures) || 6;
    var physical = core.totalFixtures(state);
    var slots = totalFixtureSlots();
    var filled = Math.max(0, Math.min(maxTotal, slots));
    meter.hidden = currentStep !== 4;
    meter.classList.remove('is-near-limit', 'is-at-limit');
    if (selectors.fixtureMeterCount) {
      selectors.fixtureMeterCount.textContent =
        'You can select at most ' + maxTotal + ' lights (' + physical + ' selected)';
    }
    if (selectors.fixtureMeterNote) {
      selectors.fixtureMeterNote.textContent = formatSlotCount(filled) + ' / ' + maxTotal;
    }
    if (selectors.fixtureMeterCells) {
      paintSlotCells(selectors.fixtureMeterCells.querySelectorAll('[data-meter-cell]'), filled);
      selectors.fixtureMeterCells.setAttribute(
        'aria-label',
        formatSlotCount(filled) + ' of ' + maxTotal + ' light slots used'
      );
    }
    if (selectors.fixtureMeterFill) {
      selectors.fixtureMeterFill.style.width =
        Math.max(0, Math.min(100, (filled / maxTotal) * 100)) + '%';
    }
    renderFixtureBranchNav();
  }
  function renderFixtureBranchNav() {
    var nav = selectors.fixtureBranchNav;
    if (!nav) return;
    nav.innerHTML = '';
    var show = currentStep === 4 && state.installations.length > 1;
    nav.hidden = !show;
    if (!show) return;
    clampFixtureBranch();
    state.installations.forEach(function (branch, index) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className =
        'umbrella-configurator__fixture-branch-btn' +
        (index === fixtureBranchIndex ? ' is-active' : '');
      btn.textContent = branchTitle(branch);
      btn.setAttribute('aria-pressed', index === fixtureBranchIndex ? 'true' : 'false');
      btn.addEventListener('click', function () {
        if (index === fixtureBranchIndex) return;
        fixtureBranchIndex = index;
        clearErrors();
        renderAll();
        scrollToConfiguratorTop();
      });
      nav.appendChild(btn);
    });
  }
  function scrollBuildListToKey(key) {
    if (!key || !selectors.buildList) return;
    var line = selectors.buildList.querySelector('[data-build-key="' + key + '"]');
    if (!line) return;
    var list = selectors.buildList;
    var lineTop = line.offsetTop;
    var target = Math.max(0, lineTop - Math.max(24, list.clientHeight / 3));
    try {
      list.scrollTo({ top: target, behavior: 'smooth' });
    } catch (e) {
      list.scrollTop = target;
    }
    line.classList.add('is-just-added');
    window.setTimeout(function () {
      line.classList.remove('is-just-added');
    }, 1200);
  }
  function fixtureSlotWeight(fixtureId) {
    return core.fixtureSlotWeight ? core.fixtureSlotWeight(fixtureId) : 1;
  }
  function roundFixtureSlots(value) {
    return core.roundFixtureSlots
      ? core.roundFixtureSlots(value)
      : Math.round(Number(value || 0) * 2) / 2;
  }
  function totalFixtureSlots() {
    return core.totalFixtureSlots ? core.totalFixtureSlots(state) : core.totalFixtures(state);
  }
  function setFixtureQuantity(branch, fixtureId, next) {
    var current = Number(branch.fixtures[fixtureId] || 0);
    var weight = fixtureSlotWeight(fixtureId);
    var currentSlots = roundFixtureSlots(current * weight);
    var otherSlots = Math.max(0, roundFixtureSlots(totalFixtureSlots() - currentSlots));
    var maxTotal = Number(rules.maxTotalFixtures) || 6;
    var maxForThis = Math.max(0, Math.floor((maxTotal - otherSlots + 1e-9) / weight));
    var value = Math.max(0, Math.min(maxForThis, Number(next) || 0));
    if (Number(next) > maxForThis) {
      var err = root.querySelector('[data-fixture-error]');
      if (err) {
        err.hidden = false;
        err.textContent =
          weight !== 1
            ? 'This light counts as ' +
              formatSlotCount(weight) +
              ' toward the ' +
              maxTotal +
              '-light kit limit.'
            : 'This patio kit allows up to ' + maxTotal + ' fixtures in total (all installations).';
      }
    } else {
      var ok = root.querySelector('[data-fixture-error]');
      if (
        ok &&
        (ok.textContent.indexOf('This patio kit allows up to') === 0 ||
          ok.textContent.indexOf('This higher-wattage light counts as') === 0 ||
          ok.textContent.indexOf('This light counts as') === 0)
      ) {
        ok.hidden = true;
        ok.textContent = '';
      }
    }
    var fixturesState = Object.assign({}, branch.fixtures);
    if (value) fixturesState[fixtureId] = value;
    else delete fixturesState[fixtureId];
    if (value > current) {
      pendingBuildScrollKey = 'fixture-' + branch.branchId + '-' + fixtureId;
    }
    updateBranch(branch.branchId, { fixtures: fixturesState });
    renderAll();
  }
  function buildSlotWeightTip(weight) {
    var tip = document.createElement('span');
    tip.className = 'umbrella-configurator__fx-slot-tip';
    tip.tabIndex = 0;
    var label =
      weight > 1
        ? 'Counts as two lights'
        : weight < 1
          ? 'Counts as half a light'
          : 'Counts as one light';
    var bubble =
      weight > 1
        ? 'Higher wattage — one of these counts as two lights toward your 6-light kit limit.'
        : weight < 1
          ? 'Compact pendant — one of these counts as half a light toward your 6-light kit limit.'
          : 'Counts as one light toward your 6-light kit limit.';
    tip.setAttribute('aria-label', label);
    tip.innerHTML =
      '<span class="umbrella-configurator__fx-slot-tip-icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" fill="none">' +
      '<circle cx="12" cy="12" r="9.25" stroke="currentColor" stroke-width="1.7"/>' +
      '<path d="M12 10.5V16.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
      '<circle cx="12" cy="7.75" r="1.1" fill="currentColor"/>' +
      '</svg></span>' +
      '<span class="umbrella-configurator__fx-slot-tip-bubble" role="tooltip">' +
      bubble +
      '</span>';
    return tip;
  }
  // ─── Step 4 – Fixture rendering ─────────────────────────────────────────────

  function renderFixtures() {
    selectors.fixtures.innerHTML = '';
    if (!state.lightingMode) return;
    clampFixtureBranch();
    var branch = state.installations[fixtureBranchIndex];
    if (!branch) return;
    var installation = core.getInstallation(rules, branch.installationId);
    // One card per synced option (name + image + variantId) — do not collapse into families.
    var fixtures =
      branch.shapeId && installation.fixturesByShape[branch.shapeId]
        ? installation.fixturesByShape[branch.shapeId]
        : [];
    var maxTotal = Number(rules.maxTotalFixtures) || 6;
    var slotsUsed = totalFixtureSlots();
    var remainingSlots = Math.max(0, maxTotal - slotsUsed);
    if (installation.trackChoice === 'required' && installation.tracks && installation.tracks.length) {
      selectors.fixtures.appendChild(renderRequiredTrackColumn(branch, installation));
    }
    var grid = document.createElement('div');
    grid.className = 'umbrella-configurator__fx-grid';
    fixtures.forEach(function (fixture) {
      var sku = fixture.sku || fixture.id;
      var quantity = Number(branch.fixtures[fixture.id] || 0);
      var weight = fixtureSlotWeight(fixture.id);
      var card = document.createElement('article');
      card.className =
        'umbrella-configurator__fx-card' +
        (quantity ? ' is-selected' : '') +
        (weight > 1 ? ' is-double-slot' : '') +
        (weight < 1 ? ' is-half-slot' : '');
      card.dataset.fixtureId = fixture.id;
      if (fixture.cartVariantId) card.dataset.variantId = String(fixture.cartVariantId);
      var media = document.createElement('div');
      media.className = 'umbrella-configurator__fx-media';
      var img = document.createElement('img');
      img.src = fixtureImage(fixture);
      img.alt = fixture.label || sku;
      img.loading = 'lazy';
      img.decoding = 'async';
      media.appendChild(img);
      var body = document.createElement('div');
      body.className = 'umbrella-configurator__fx-body';
      var titleRow = document.createElement('div');
      titleRow.className = 'umbrella-configurator__fx-title-row';
      var title = document.createElement('h3');
      title.textContent = fixture.label || sku;
      var controls = document.createElement('span');
      controls.className = 'umbrella-configurator__fx-actions';
      if (weight !== 1) controls.appendChild(buildSlotWeightTip(weight));
      if (!quantity) {
        var add = document.createElement('button');
        add.type = 'button';
        add.className = 'btn btn-sm btn-primary';
        add.textContent = 'Add';
        if (remainingSlots + 1e-9 < weight) {
          add.disabled = true;
          add.title =
            weight !== 1
              ? 'Needs ' + formatSlotCount(weight) + ' open slot(s)'
              : 'Max ' + maxTotal + ' fixtures for the whole kit';
        }
        add.addEventListener('click', function () {
          setFixtureQuantity(branch, fixture.id, 1);
        });
        controls.appendChild(add);
      } else {
        var stepper = document.createElement('div');
        stepper.className = 'umbrella-configurator__qty-stepper';
        var minus = document.createElement('button');
        minus.type = 'button';
        minus.setAttribute('aria-label', 'Decrease');
        minus.innerHTML = iconSvg('minus');
        var count = document.createElement('span');
        count.textContent = String(quantity);
        var plus = document.createElement('button');
        plus.type = 'button';
        plus.setAttribute('aria-label', 'Increase');
        plus.innerHTML = iconSvg('plus');
        if (remainingSlots + 1e-9 < weight) {
          plus.disabled = true;
          plus.title =
            weight !== 1
              ? 'Needs ' + formatSlotCount(weight) + ' open slot(s)'
              : 'Max ' + maxTotal + ' fixtures for the whole kit';
        }
        minus.addEventListener('click', function () {
          setFixtureQuantity(branch, fixture.id, quantity - 1);
        });
        plus.addEventListener('click', function () {
          setFixtureQuantity(branch, fixture.id, quantity + 1);
        });
        stepper.appendChild(minus);
        stepper.appendChild(count);
        stepper.appendChild(plus);
        controls.appendChild(stepper);
      }
      titleRow.appendChild(title);
      titleRow.appendChild(controls);
      body.appendChild(titleRow);
      var foot = document.createElement('div');
      foot.className = 'umbrella-configurator__fx-foot';
      var priceEl = document.createElement('span');
      priceEl.className = 'umbrella-configurator__fx-price';
      priceEl.textContent = fixtureUnitPriceText(fixture) || '—';
      var specUi = buildSpecDetailsControls(card, sku);
      foot.appendChild(priceEl);
      foot.appendChild(specUi.button);
      body.appendChild(foot);
      card.appendChild(media);
      card.appendChild(body);
      grid.appendChild(card);
    });
    selectors.fixtures.appendChild(grid);
    updateFixtureMeter();
  }
  function renderRequiredTrackColumn(branch, installation) {
    var section = document.createElement('section');
    section.className = 'umbrella-configurator__fx-size';
    var column = document.createElement('div');
    column.className = 'umbrella-configurator__fx-size-col';
    var heading = document.createElement('p');
    heading.className = 'umbrella-configurator__fx-size-kicker';
    heading.textContent = 'Required · choose one';
    column.appendChild(heading);
    installation.tracks.forEach(function (track) {
      var selected = branch.trackId === track.id;
      var card = document.createElement('article');
      card.className = 'umbrella-configurator__fx-card' + (selected ? ' is-selected' : '');
      card.dataset.trackId = track.id;
      if (track.cartVariantId) card.dataset.variantId = String(track.cartVariantId);
      var media = document.createElement('div');
      media.className = 'umbrella-configurator__fx-media';
      var img = document.createElement('img');
      img.src = track.imageUrl || '';
      img.alt = (track.label || 'Track') + ' ' + (track.sizeLabel || '');
      img.loading = 'lazy';
      img.decoding = 'async';
      media.appendChild(img);
      var body = document.createElement('div');
      body.className = 'umbrella-configurator__fx-body';
      var title = document.createElement('h3');
      title.textContent = track.label || track.id;
      var spec = document.createElement('p');
      spec.className = 'umbrella-configurator__fx-spec';
      spec.textContent = track.sizeLabel || '';
      body.appendChild(title);
      body.appendChild(spec);
      var foot = document.createElement('div');
      foot.className = 'umbrella-configurator__fx-foot';
      var priceEl = document.createElement('span');
      priceEl.className = 'umbrella-configurator__fx-price';
      priceEl.textContent = fixtureUnitPriceText(track) || '—';
      foot.appendChild(priceEl);
      var choose = document.createElement('button');
      choose.type = 'button';
      choose.className = 'btn btn-sm btn-primary';
      choose.textContent = selected ? 'Selected' : 'Select';
      choose.setAttribute('aria-pressed', selected ? 'true' : 'false');
      choose.addEventListener('click', function () {
        if (branch.trackId === track.id) return;
        var sizeError = root.querySelector('[data-fixture-error]');
        if (sizeError && sizeError.textContent.indexOf('Please choose one ZCHW-F-P-800') === 0) {
          sizeError.hidden = true;
          sizeError.textContent = '';
        }
        pendingBuildScrollKey = 'track-' + branch.branchId + '-' + track.id;
        updateBranch(branch.branchId, { trackId: track.id });
        renderAll();
      });
      foot.appendChild(choose);
      body.appendChild(foot);
      card.appendChild(media);
      card.appendChild(body);
      column.appendChild(card);
    });
    section.appendChild(column);
    return section;
  }
  function connectorImage(count) {
    var files = {};
    try {
      files = JSON.parse(root.getAttribute('data-splitter-images') || '{}');
    } catch (err) {
      files = {};
    }
    if (count >= 3) return files['3'] || '';
    if (count === 2) return files['2'] || '';
    if (count === 1) return files['1'] || '';
    return '';
  }

  // Stamp theme accessory thumbs onto rules so ATC writes _lineImage for cart Included rows.
  (function stampAccessoryImages() {
    var rulesRef = rules || window.LEAVES_CONFIGURATOR_RULES;
    if (!rulesRef) return;
    Object.keys(rulesRef.sharedCableByColorAndLength || {}).forEach(function (colorId) {
      var url = cableImages[colorId] || cableImages.black || '';
      Object.keys(rulesRef.sharedCableByColorAndLength[colorId] || {}).forEach(function (length) {
        var cable = rulesRef.sharedCableByColorAndLength[colorId][length];
        if (cable && url) cable.imageUrl = url;
      });
    });
    Object.keys(rulesRef.splittersByBranchCount || {}).forEach(function (count) {
      var splitter = rulesRef.splittersByBranchCount[count];
      if (!splitter) return;
      var n = Number(count) || 1;
      splitter.imageUrl = connectorImage(n) || splitter.imageUrl || '';
    });
    if (rulesRef.adapter) {
      rulesRef.adapter.imageUrl =
        rulesRef.adapter.imageUrl || connectorImage(1) || cableImages.black || '';
    }
  })();

  function buildRowHtml(slot, title, quantity, imageUrl, swatch, price, options) {
    options = options || {};
    var qty = Math.max(1, Number(quantity) || 1);
    var compact = !!options.compact;
    var textOnly = !!options.textOnly;
    var component = !!options.component;
    var allowZoom = !textOnly && options.allowZoom !== false;
    var showQty = compact ? qty > 1 : true;
    if (options.hideQty) showQty = false;
    // Match cart-page product info: title + optional info (e.g. Color / Length), then qty.
    var parts = [];
    if (options.info) parts.push(String(options.info));
    if (showQty) parts.push('Qty ' + qty);
    var meta = parts.join(' · ');
    var media = '';
    if (!textOnly) {
      media = swatch
        ? '<span class="umbrella-configurator__thumb" style="background:' +
          esc(swatch) +
          '" aria-hidden="true"></span>'
        : '<span class="umbrella-configurator__thumb"' +
          (slot ? ' data-image-slot="' + esc(slot) + '"' : '') +
          '>' +
          (imageUrl
            ? '<img src="' + esc(imageUrl) + '" alt="">'
            : esc(String(title || '·').slice(0, 1))) +
          '</span>';
    }
    return (
      '<div class="umbrella-configurator__build-line' +
      (textOnly ? ' is-text-only' : '') +
      (compact ? ' is-compact' : '') +
      (component ? ' is-component' : '') +
      '"' +
      (allowZoom
        ? ' data-zoom-item data-zoom-title="' +
          esc(title) +
          '" data-zoom-meta="' +
          esc(meta) +
          '"' +
          (imageUrl ? ' data-zoom-image="' + esc(imageUrl) + '"' : '') +
          (swatch ? ' data-zoom-swatch="' + esc(swatch) + '"' : '') +
          (slot && String(slot).indexOf('installation-') === 0 ? ' data-zoom-fit="cover"' : '')
        : '') +
      (options.key ? ' data-build-key="' + esc(options.key) + '"' : '') +
      '>' +
      media +
      '<div><strong>' +
      esc(title) +
      '</strong>' +
      (meta ? '<small>' + esc(meta) + '</small>' : '') +
      '</div>' +
      (price ? '<em>' + esc(price) + '</em>' : '<em class="is-empty">—</em>') +
      '</div>'
    );
  }

  function cableBuildInfo(branch) {
    if (core.cableDisplayLabel) {
      var labeled = core.cableDisplayLabel(rules, branch);
      if (labeled) return labeled;
    }
    var colorPart = branch.colorId ? 'Color: ' + colorShort(branch.colorId) : 'Color: —';
    var lengthPart = branch.lengthMeters
      ? 'Length: ' + formatLength(branch.lengthMeters)
      : 'Length: —';
    return colorPart + ' / ' + lengthPart;
  }
  function syncSideAlignToCards() {
    var side = selectors.side;
    var grid = selectors.installations;
    var content = root.querySelector('.umbrella-configurator__content');
    if (!side) return;
    if (
      currentStep !== 1 ||
      window.matchMedia('(max-width: 920px)').matches ||
      !grid ||
      !content
    ) {
      side.style.paddingTop = '';
      return;
    }
    // Align white box top edge with left installation cards top edge
    var gap = Math.round(grid.getBoundingClientRect().top - content.getBoundingClientRect().top);
    if (gap < 0) gap = 0;
    side.style.paddingTop = gap + 'px';
  }
  function syncBuildCardPin() {
    var card = selectors.buildCard;
    var side = selectors.side;
    if (!card || !side) return;
    // Never derive padding from scroll position. Mid-page re-renders used to
    // bake a huge paddingTop and freeze the sticky cart until a full reload.
    if (
      currentStep === 1 ||
      window.matchMedia('(max-width: 920px)').matches ||
      root.classList.contains('is-mode-gallery')
    ) {
      card.style.top = '';
      card.style.position = '';
      syncSideAlignToCards();
      return;
    }
    side.style.paddingTop = '';
    card.style.position = 'sticky';
    var h = card.offsetHeight || 0;
    var top = Math.round((window.innerHeight - h) / 2);
    if (top < 16) top = 16;
    card.style.top = top + 'px';
  }
  function hideItemZoom() {
    if (!selectors.itemZoom) return;
    selectors.itemZoom.hidden = true;
    selectors.itemZoom.classList.remove('is-visible');
  }
  function showItemZoom(line) {
    var zoom = selectors.itemZoom;
    if (!zoom || !line) return;
    var media = zoom.querySelector('[data-item-zoom-media]');
    var titleEl = zoom.querySelector('[data-item-zoom-title]');
    var metaEl = zoom.querySelector('[data-item-zoom-meta]');
    var image = line.getAttribute('data-zoom-image') || '';
    var swatch = line.getAttribute('data-zoom-swatch') || '';
    var title = line.getAttribute('data-zoom-title') || '';
    var fit = line.getAttribute('data-zoom-fit') || '';
    titleEl.textContent = title;
    metaEl.textContent = line.getAttribute('data-zoom-meta') || '';
    media.setAttribute('data-fit', fit);
    if (image) {
      media.innerHTML = '<img src="' + esc(image) + '" alt="">';
      media.style.background = '#f7f7f5';
    } else if (swatch) {
      media.innerHTML = '';
      media.style.background = swatch;
    } else {
      media.innerHTML = '<span>' + esc(String(title || '·').slice(0, 1)) + '</span>';
      media.style.background = '#f7f7f5';
    }
    zoom.hidden = false;
    zoom.classList.remove('is-visible');
    var box = line.getBoundingClientRect();
    var width = zoom.offsetWidth || 420;
    var height = zoom.offsetHeight || 320;
    var left = box.left - 16 - width;
    if (left < 16) left = Math.min(window.innerWidth - width - 16, box.right + 16);
    var top = box.top + box.height / 2 - height / 2;
    if (top < 16) top = 16;
    if (top + height > window.innerHeight - 16) top = window.innerHeight - 16 - height;
    zoom.style.left = Math.round(left) + 'px';
    zoom.style.top = Math.round(top) + 'px';
    zoom.offsetWidth;
    zoom.classList.add('is-visible');
  }
  function priceLookup() {
    if (!pricing || !priceCatalog) return {};
    var quote = core.buildPriceQuote(rules, state, priceCatalog);
    var map = {};
    quote.lines.forEach(function (line) {
      map[line.key] = line;
    });
    return { quote: quote, map: map };
  }
  function linePriceText(priced) {
    if (!priced) return '';
    if (priced.priced && priced.lineMoney) return priced.lineMoney;
    if (priceCatalog && priceCatalog.loaded) return 'Pending sync';
    return '';
  }
  function ensurePriceCatalog() {
    if (!pricing || !priceCatalog) return Promise.resolve(null);
    return pricing.loadCatalog(rules, { catalog: priceCatalog }).then(function () {
      renderBuildCard();
      if (currentStep === 2) {
        state.installations.forEach(function (branch) {
          syncWireLine(branch.branchId);
        });
      }
      if (currentStep === 4) renderFixtures();
      return priceCatalog;
    });
  }
  function visibleSplitter() {
    var count = state.installations.length;
    if (count < 2) return null;
    return rules.splittersByBranchCount[count] || null;
  }
  // ─── Build card (sidebar summary) ───────────────────────────────────────────

  function renderBuildCard() {
    var branchCount = state.installations.length;
    var splitter = visibleSplitter();
    var total = core.totalFixtures(state);
    var slots = totalFixtureSlots();
    var priced = priceLookup();
    var priceMap = priced.map || {};
    var quote = priced.quote || null;
    var itemCount = 0;
    var html = '';
    var heading = root.querySelector('.umbrella-configurator__build-heading');
    var buildMeta = root.querySelector('.umbrella-configurator__build-meta');
    root.classList.toggle('is-build-compact', currentStep !== 1);
    if (heading) heading.hidden = currentStep !== 1;
    if (buildMeta) buildMeta.hidden = currentStep !== 4;
    if (currentStep === 1) {
      if (!branchCount) {
        html =
          '<p class="umbrella-configurator__build-empty">Tap an installation on the left.<br>One needs no splitter; two use a 1-to-2; three use a 1-to-3.</p>';
      } else if (splitter) {
        html =
          '<section class="umbrella-configurator__build-group">' +
          buildRowHtml(
            'splitter-' + branchCount,
            splitter.label,
            1,
            connectorImage(branchCount),
            '',
            linePriceText(priceMap['splitter-' + branchCount])
          ) +
          '</section>';
        itemCount = 1;
      } else {
        html = '<p class="umbrella-configurator__build-empty">A single installation does not need a splitter.</p>';
      }
    } else if (!branchCount) {
      html =
        '<p class="umbrella-configurator__build-empty">Nothing selected yet.<br>Start by tapping an installation on the left.</p>';
    } else {
      var compact = { compact: true, component: true };
      if (state.lightingMode) {
        html +=
          '<p class="umbrella-configurator__build-mode-label">' +
          esc(state.lightingMode === 'cw' ? 'Lighting · Basic model' : 'Lighting · Vibrant Color model') +
          '</p>';
        itemCount += 1;
      }
      if (priceMap.adapter && priceMap.adapter.priced) {
        html +=
          '<section class="umbrella-configurator__build-shared">' +
          '<div class="umbrella-configurator__build-kit-items">' +
          buildRowHtml(
            'adapter',
            rules.adapter.label || 'Adapter',
            1,
            '',
            '',
            linePriceText(priceMap.adapter),
            compact
          ) +
          '</div></section>';
        itemCount += 1;
      }
      state.installations.forEach(function (branch, index) {
        var installation = core.getInstallation(rules, branch.installationId);
        var token = branch.branchId || 'branch-' + (index + 1);
        var items = buildRowHtml(
          'cable-' + token,
          'Cable',
          1,
          cableImages[branch.colorId] || cableImages.black || '',
          '',
          linePriceText(priceMap['cable-' + token]),
          Object.assign({}, compact, {
            key: 'cable-' + token,
            info: cableBuildInfo(branch),
            hideQty: true,
          })
        );
        itemCount += 2;
        if (installation.trackChoice === 'required' && branch.trackId) {
          var chosenTrack = (installation.tracks || []).find(function (track) {
            return track.id === branch.trackId;
          });
          if (chosenTrack) {
            items += buildRowHtml(
              'track-' + token,
              chosenTrack.label || 'Track',
              1,
              chosenTrack.imageUrl || '',
              '',
              linePriceText(priceMap['track-' + token + '-' + branch.trackId]),
              Object.assign({}, compact, {
                key: 'track-' + token + '-' + branch.trackId,
                info: chosenTrack.sizeLabel || '',
                hideQty: true,
              })
            );
            itemCount += 1;
          }
        }
        Object.keys(branch.fixtures || {}).forEach(function (id) {
          var qty = Number(branch.fixtures[id] || 0);
          if (!qty) return;
          var fixture = (installation.fixturesByShape[branch.shapeId] || []).find(function (item) {
            return item.id === id;
          });
          items += buildRowHtml(
            'fixture-' + id,
            fixture ? fixture.label || fixture.sku || fixture.id : id,
            qty,
            fixture ? fixtureImage(fixture) : '',
            '',
            linePriceText(priceMap['fixture-' + token + '-' + id]),
            Object.assign({}, compact, {
              key: 'fixture-' + token + '-' + id,
            })
          );
          itemCount += 1;
        });
        html +=
          '<section class="umbrella-configurator__build-kit' +
          (index === 0 ? ' is-first' : '') +
          '">' +
          '<h3 class="umbrella-configurator__build-kit-title">' +
          esc(branchTitle(branch)) +
          '</h3>' +
          '<div class="umbrella-configurator__build-kit-items">' +
          items +
          '</div></section>';
      });
      if (splitter) {
        html +=
          '<section class="umbrella-configurator__build-shared">' +
          '<div class="umbrella-configurator__build-kit-items">' +
          buildRowHtml(
            'splitter-' + state.installations.length,
            splitter.label,
            1,
            connectorImage(state.installations.length),
            '',
            linePriceText(priceMap['splitter-' + state.installations.length]),
            compact
          ) +
          '</div></section>';
        itemCount += 1;
      }
    }
    if (selectors.buildCount) {
      if (currentStep === 1) {
        selectors.buildCount.textContent = splitter
          ? splitter.label
          : branchCount
            ? 'No accessory needed'
            : 'No accessory selected';
      } else {
        selectors.buildCount.textContent = '';
      }
    }
    hideItemZoom();
    if (selectors.buildList) selectors.buildList.innerHTML = html;
    if (selectors.buildFixtures) {
      var maxCells = Number(rules.maxTotalFixtures) || 6;
      var filledSlots = Math.max(0, Math.min(maxCells, slots));
      selectors.buildFixtures.textContent = formatSlotCount(filledSlots);
      if (selectors.buildFixtureCells) {
        paintSlotCells(selectors.buildFixtureCells.querySelectorAll('[data-cell]'), filledSlots);
        selectors.buildFixtureCells.setAttribute(
          'aria-label',
          formatSlotCount(filledSlots) + ' of ' + maxCells + ' light slots used'
        );
      }
    }
    if (selectors.buildTotal && selectors.buildTotalAmount) {
      var showTotal = currentStep !== 1 && branchCount > 0;
      selectors.buildTotal.hidden = !showTotal;
      if (!showTotal) {
        selectors.buildTotalAmount.textContent = '—';
      } else if (quote && quote.catalogLoaded && quote.complete) {
        selectors.buildTotalAmount.textContent = quote.totalMoney || '—';
      } else if (quote && quote.catalogLoaded) {
        selectors.buildTotalAmount.textContent = 'Pending sync';
      } else {
        selectors.buildTotalAmount.textContent = '…';
      }
    }
    if (pendingBuildScrollKey) {
      var scrollKey = pendingBuildScrollKey;
      pendingBuildScrollKey = '';
      window.requestAnimationFrame(function () {
        scrollBuildListToKey(scrollKey);
      });
    }
    window.requestAnimationFrame(syncBuildCardPin);
  }
  function validateCurrentStep() {
    clearErrors();
    if (currentStep === 1 && !state.installations.length) {
      error('[data-installation-error]', 'Please select at least one installation method.');
      return false;
    }
    if (
      currentStep === 2 &&
      state.installations.some(function (branch) {
        return !branch.colorId || !branch.lengthMeters;
      })
    ) {
      error('[data-line-error]', 'Please choose colour and length for every cable branch.');
      return false;
    }
    if (currentStep === 3) {
      if (!state.lightingMode) {
        error('[data-control-error]', 'Please choose Basic model or Vibrant Color model.');
        return false;
      }
    }
    if (currentStep === 4) {
      clampFixtureBranch();
      var currentBranch = state.installations[fixtureBranchIndex];
      var currentInstallation = core.getInstallation(rules, currentBranch && currentBranch.installationId);
      if (
        currentInstallation &&
        currentInstallation.trackChoice === 'required' &&
        !(currentInstallation.tracks || []).some(function (track) {
          return track.id === currentBranch.trackId;
        })
      ) {
        error('[data-fixture-error]', 'Please choose one ZCHW-F-P-800 size.');
        return false;
      }
      if (!branchFixtureCount(currentBranch)) {
        error('[data-fixture-error]', 'Please select at least one fixture for the current installation.');
        return false;
      }
      // Last fixture group → Confirm: run full kit validation before add to cart.
      if (fixtureBranchIndex >= state.installations.length - 1) {
        var result = core.validateState(rules, state);
        if (!result.valid) {
          error('[data-submit-error]', result.errors.join(' '));
          return false;
        }
      }
    }
    return true;
  }
  function renderStep() {
    steps.forEach(function (step) {
      var visible = Number(step.dataset.step) === currentStep;
      step.hidden = !visible;
      step.classList.toggle('is-visible', visible);
    });
    if (selectors.step3) selectors.step3.classList.add('is-mode-only');
    if (currentStep === 4 && state.installations[fixtureBranchIndex]) {
      clampFixtureBranch();
      var currentInstallation = core.getInstallation(
        rules,
        state.installations[fixtureBranchIndex].installationId
      );
      selectors.title.textContent = 'Choose fixtures for “' + branchTitle(state.installations[fixtureBranchIndex]) + '”.';
      selectors.description.textContent =
        'Installation ' +
        (fixtureBranchIndex + 1) +
        ' of ' +
        state.installations.length +
        '. Finish this group, then continue to the next.';
      if (selectors.fixtureHeading)
        selectors.fixtureHeading.textContent = currentInstallation.label;
      if (selectors.fixtureHint) {
        selectors.fixtureHint.hidden = false;
        selectors.fixtureHint.textContent =
          'Install ' +
          (fixtureBranchIndex + 1) +
          ' / ' +
          state.installations.length +
          ' — max ' +
          (rules.maxTotalFixtures || 6) +
          ' lights';
      }
    } else {
      selectors.title.textContent = copy[currentStep][0];
      selectors.description.textContent = copy[currentStep][1];
      if (selectors.fixtureHeading) selectors.fixtureHeading.textContent = 'Lighting';
      if (selectors.fixtureHint) {
        selectors.fixtureHint.hidden = false;
        selectors.fixtureHint.textContent =
          'You can select at most ' + (rules.maxTotalFixtures || 6) + ' lights';
      }
    }
    if (selectors.description) {
      selectors.description.hidden = !String(selectors.description.textContent || '').trim();
    }
    if (selectors.eyebrow) selectors.eyebrow.textContent = 'Step ' + currentStep + ' of 4';
    root.classList.toggle('is-step-1', currentStep === 1);
    root.classList.toggle('is-wire-step', currentStep === 2);
    root.classList.toggle('is-mode-gallery', currentStep === 3);
    root.classList.toggle('is-fixture-step', currentStep === 4);
    updateFixtureMeter();
    if (window.LeavesCableCard) {
      window.LeavesCableCard.setStepActive(currentStep === 2 && !reduceMotion);
    }
    selectors.back.hidden = currentStep === 1;
    if (selectors.headerBack) selectors.headerBack.disabled = currentStep === 1;
    if (selectors.headerNext) selectors.headerNext.disabled = submitting;
    var nextText = 'Next';
    var onLastFixtureBranch =
      currentStep === 4 && fixtureBranchIndex >= Math.max(0, state.installations.length - 1);
    if (onLastFixtureBranch) {
      if (submitting) nextText = 'Adding…';
      else nextText = editingCartKeys.length ? 'Update cart' : 'Confirm';
    }
    splitButtonLabel(selectors.next.querySelector('[data-next-label]'), nextText);
    splitButtonLabel(selectors.back.querySelector('[data-back-label]'), 'Back');
    selectors.next.disabled = submitting;
    if (selectors.progress) selectors.progress.style.width = ((currentStep - 1) / 3) * 84 + '%';
    Array.prototype.forEach.call(root.querySelectorAll('[data-progress-step]'), function (item) {
      var n = Number(item.dataset.progressStep);
      item.classList.toggle('is-active', n === currentStep);
      item.classList.toggle('is-complete', n < currentStep);
      var badge = item.querySelector('b');
      if (badge) {
        badge.hidden = n <= currentStep;
        badge.textContent = String(n);
      }
    });
    renderBuildCard();
    if (window.LeavesConnector) {
      window.LeavesConnector.setCount(state.installations.length);
    }
  }
  function renderAll() {
    renderInstallations();
    renderLengthsAndColors();
    renderModes();
    renderFixtures();
    renderStep();
  }
  // ─── Add to cart ─────────────────────────────────────────────────────────────

  function addToCart() {
    function placeOrder(catalog) {
      var result = core.buildCartItems(rules, state, catalog || null);
      if (!result.valid) {
        error('[data-submit-error]', result.errors.join(' '));
        submitting = false;
        if (submitWatchdog) {
          window.clearTimeout(submitWatchdog);
          submitWatchdog = null;
        }
        renderStep();
        return;
      }
      // Strip any accidental price fields before talking to Shopify.
      // Keep parent_id so Shopify nests components under the kit line.
      var items = result.items.map(function (item) {
        var safeItem = {
          id: item.id,
          quantity: item.quantity,
          properties: item.properties || {},
        };
        if (item.parent_id) safeItem.parent_id = item.parent_id;
        return safeItem;
      });
      var presetId = readPresetId();
      var presetCard = null;
      (window.LEAVES_SCENE_PRESETS || []).forEach(function (item) {
        if (item && item.id === presetId) presetCard = item;
      });
      if (presetCard) {
        var sceneImages = window.LEAVES_SCENE_IMAGES || {};
        items.forEach(function (item) {
          if (item.parent_id) return;
          item.properties._leavesTitle = presetCard.title;
          if (sceneImages[presetCard.id]) item.properties._leavesImage = sceneImages[presetCard.id];
        });
      }
      var parentProps = items[0] && items[0].properties ? items[0].properties : {};
      if (parentProps._itemKey && parentProps._leavesState) {
        try {
          window.sessionStorage.setItem(
            CONFIG_EDIT_STORAGE_PREFIX + parentProps._itemKey,
            parentProps._leavesState
          );
        } catch (storageError) {}
      }

      function cartSectionIds() {
        var ids = [];
        document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (node) {
          if (node.dataset.sectionId) ids.push(node.dataset.sectionId);
        });
        return ids;
      }

      function goToCartPage() {
        window.location.assign('/cart');
      }

      function postAdd() {
        var sectionIds = cartSectionIds();
        var body = { items: items };
        if (sectionIds.length) {
          body.sections = sectionIds.join(',');
          body.sections_url = window.location.pathname;
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        }).then(function (response) {
          return response.text().then(function (raw) {
            var payload = null;
            try {
              payload = raw ? JSON.parse(raw) : null;
            } catch (parseErr) {
              payload = null;
            }
            if (!response.ok) {
              var msg =
                (payload && (payload.description || payload.message || payload.error)) ||
                raw ||
                'cart_add_failed';
              var err = new Error(String(msg));
              err.status = response.status;
              err.payload = payload;
              throw err;
            }
            return payload;
          });
        });
      }

      var chain = Promise.resolve();
      if (editingCartKeys.length) {
        var updates = {};
        editingCartKeys.forEach(function (key) {
          updates[key] = 0;
        });
        chain = fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates }),
        }).then(function (response) {
          return response.text().then(function (raw) {
            var payload = null;
            try {
              payload = raw ? JSON.parse(raw) : null;
            } catch (parseErr) {
              payload = null;
            }
            if (!response.ok) {
              var msg =
                (payload && (payload.description || payload.message || payload.error)) ||
                raw ||
                'cart_update_failed';
              throw new Error(String(msg));
            }
            return payload;
          });
        });
      }

      chain
        .then(postAdd)
        .then(function () {
          editingCartKeys = [];
          editingItemKey = '';
          submitting = false;
          if (submitWatchdog) {
            window.clearTimeout(submitWatchdog);
            submitWatchdog = null;
          }
          goToCartPage();
        })
        .catch(function (err) {
          submitting = false;
          if (submitWatchdog) {
            window.clearTimeout(submitWatchdog);
            submitWatchdog = null;
          }
          var detail = err && err.message ? String(err.message) : '';
          error(
            '[data-submit-error]',
            detail && detail !== 'cart_add_failed' && detail !== 'cart_update_failed'
              ? detail
              : 'The cart could not accept this configuration. Please try again shortly.'
          );
          renderStep();
        });
    }
    clearErrors();
    submitting = true;
    renderStep();
    // Failsafe: never leave Confirm permanently disabled if a request hangs.
    if (submitWatchdog) window.clearTimeout(submitWatchdog);
    submitWatchdog = window.setTimeout(function () {
      submitWatchdog = null;
      if (!submitting) return;
      submitting = false;
      error(
        '[data-submit-error]',
        'Add to cart is taking too long. Please check your cart, or try Confirm again.'
      );
      renderStep();
    }, 20000);
    if (
      (rules.cartMode === 'components' ||
        rules.cartMode === 'kit_with_components' ||
        rules.cartMode === 'tepo_installations') &&
      (!pricing || !priceCatalog)
    ) {
      submitting = false;
      error('[data-submit-error]', 'Security check: pricing module is not loaded. Add to cart blocked.');
      renderStep();
      return;
    }
    if (pricing && priceCatalog) {
      ensurePriceCatalog()
        .then(function (catalog) {
          try {
            placeOrder(catalog);
          } catch (syncErr) {
            submitting = false;
            error(
              '[data-submit-error]',
              (syncErr && syncErr.message) || 'Could not build this configuration for the cart.'
            );
            renderStep();
          }
        })
        .catch(function (catalogErr) {
          if (
            rules.cartMode === 'components' ||
            rules.cartMode === 'kit_with_components' ||
            rules.cartMode === 'tepo_installations'
          ) {
            submitting = false;
            error(
              '[data-submit-error]',
              (catalogErr && catalogErr.message) ||
                'Could not verify the Shopify price catalog. Add to cart blocked.'
            );
            renderStep();
            return;
          }
          placeOrder(null);
        });
      return;
    }
    try {
      placeOrder(null);
    } catch (syncErr) {
      submitting = false;
      error(
        '[data-submit-error]',
        (syncErr && syncErr.message) || 'Could not build this configuration for the cart.'
      );
      renderStep();
    }
  }

  // ─── Edit-mode bootstrap (re-open cart item for editing) ────────────────────

  function collectEditableCartKeys(cart, itemKey) {
    var keys = [];
    (cart.items || []).forEach(function (item) {
      var props = item.properties || {};
      if (props._itemKey === itemKey || props._parentKey === itemKey) keys.push(item.key);
    });
    return keys;
  }

  function restoreFromEditableState(saved, itemKey, cartKeys) {
    if (!core.applyEditableState(state, saved)) return false;
    editingItemKey = itemKey || '';
    editingCartKeys = cartKeys || [];
    fixtureBranchIndex = 0;
    currentStep = 1;
    return true;
  }

  function bootstrapEditMode() {
    var params = new URLSearchParams(window.location.search || '');
    var editKey = params.get('edit') || '';
    if (!editKey) return Promise.resolve(false);

    var fromStorage = null;
    try {
      fromStorage = window.sessionStorage.getItem(CONFIG_EDIT_STORAGE_PREFIX + editKey);
    } catch (storageError) {}
    var saved = core.parseEditableState(fromStorage);

    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('cart_fetch_failed');
        return response.json();
      })
      .then(function (cart) {
        var parent = (cart.items || []).find(function (item) {
          var props = item.properties || {};
          return props._leavesKit === 'patio' && props._itemKey === editKey;
        });
        if (parent && parent.properties && parent.properties._leavesState) {
          saved = core.parseEditableState(parent.properties._leavesState) || saved;
        }
        if (!saved) return false;
        var keys = collectEditableCartKeys(cart, editKey);
        return restoreFromEditableState(saved, editKey, keys);
      })
      .catch(function () {
        if (!saved) return false;
        return restoreFromEditableState(saved, editKey, []);
      });
  }
  function scrollToConfiguratorTop() {
    // Clear pin styles first so sticky can reattach after the jump.
    if (selectors.side) selectors.side.style.paddingTop = '';
    if (selectors.buildCard) {
      selectors.buildCard.style.top = '';
      selectors.buildCard.style.position = '';
    }

    // Blur the clicked Next button so the browser does not keep the viewport
    // anchored on a sticky/footer control after the DOM refresh.
    try {
      if (document.activeElement && document.activeElement.blur) {
        document.activeElement.blur();
      }
    } catch (blurErr) {}

    // IMPORTANT: do NOT measure the sticky header. While scrolled, its
    // getBoundingClientRect().top stays ~0, so targetY ≈ current scrollY and
    // the page looks like it only "refreshed in place".
    var pageY = window.pageYOffset || window.scrollY || 0;
    var targetY = 0;
    try {
      var rect = root.getBoundingClientRect();
      targetY = Math.max(0, Math.round(rect.top + pageY));
    } catch (e) {
      targetY = 0;
    }

    function applyScroll() {
      try {
        window.scrollTo({ top: targetY, left: 0, behavior: 'auto' });
      } catch (e2) {
        window.scrollTo(0, targetY);
      }
      var scroller = document.scrollingElement || document.documentElement;
      if (scroller) scroller.scrollTop = targetY;
      document.documentElement.scrollTop = targetY;
      document.body.scrollTop = targetY;
    }

    applyScroll();
    // Re-apply after layout/scroll-anchoring from renderAll settles.
    window.requestAnimationFrame(function () {
      applyScroll();
      syncBuildCardPin();
    });
    window.setTimeout(function () {
      applyScroll();
      syncBuildCardPin();
    }, 50);
  }
  // ─── Event listeners & init ──────────────────────────────────────────────────

  selectors.next.addEventListener('click', function () {
    if (!validateCurrentStep()) return;
    if (currentStep === 4 && fixtureBranchIndex < state.installations.length - 1) {
      fixtureBranchIndex += 1;
      renderAll();
      scrollToConfiguratorTop();
      return;
    }
    if (currentStep < 4) {
      currentStep += 1;
      if (currentStep === 4) fixtureBranchIndex = 0;
      renderAll();
      if (currentStep === 4) scrollToConfiguratorTop();
    } else addToCart();
  });
  selectors.back.addEventListener('click', function () {
    clearErrors();
    if (currentStep === 4 && fixtureBranchIndex > 0) {
      fixtureBranchIndex -= 1;
      renderAll();
      scrollToConfiguratorTop();
      return;
    }
    if (currentStep > 1) {
      currentStep -= 1;
      if (currentStep === 4) {
        clampFixtureBranch();
        fixtureBranchIndex = Math.max(0, state.installations.length - 1);
      }
      renderAll();
      if (currentStep === 4) scrollToConfiguratorTop();
    }
  });
  if (selectors.headerBack) {
    selectors.headerBack.addEventListener('click', function () {
      selectors.back.click();
    });
  }
  if (selectors.headerNext) {
    selectors.headerNext.addEventListener('click', function () {
      selectors.next.click();
    });
  }
  Array.prototype.forEach.call(root.querySelectorAll('[data-progress-step]'), function (item) {
    item.setAttribute('role', 'button');
    item.tabIndex = 0;
    item.addEventListener('click', function () {
      var n = Number(item.dataset.progressStep);
      if (!n || n >= currentStep) return;
      clearErrors();
      currentStep = n;
      renderAll();
    });
    item.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      item.click();
    });
  });
  if (selectors.buildList) {
    selectors.buildList.addEventListener('pointerover', function (event) {
      var line = event.target.closest('[data-zoom-item]');
      if (!line || !selectors.buildList.contains(line)) return;
      showItemZoom(line);
    });
    selectors.buildList.addEventListener('pointerout', function (event) {
      var line = event.target.closest('[data-zoom-item]');
      if (!line) return;
      if (line.contains(event.relatedTarget)) return;
      hideItemZoom();
    });
  }
  window.addEventListener('resize', syncBuildCardPin);
  window.addEventListener('scroll', hideItemZoom, { passive: true });
  // Browser back from /cart restores this page from bfcache with submitting=true,
  // which leaves Next permanently disabled. Always clear on pageshow.
  window.addEventListener('pageshow', function () {
    if (!submitting) return;
    submitting = false;
    renderStep();
  });
  if (selectors.buildCard && window.ResizeObserver) {
    new window.ResizeObserver(syncBuildCardPin).observe(selectors.buildCard);
  }
  if (selectors.installations && window.ResizeObserver) {
    new window.ResizeObserver(syncSideAlignToCards).observe(selectors.installations);
  }
  var mainCol = root.querySelector('.umbrella-configurator__main');
  if (mainCol && window.ResizeObserver) {
    new window.ResizeObserver(syncSideAlignToCards).observe(mainCol);
  }
  if (window.LeavesConnector) {
    window.LeavesConnector.mount(root.querySelector('[data-connector-root]'));
  }
  function applyScenePreset() {
    var params;
    try {
      params = new URLSearchParams(window.location.search || '');
    } catch (err) {
      return false;
    }
    var presetId = String(params.get('preset') || '').trim();
    var list = window.LEAVES_SCENE_PRESETS || [];
    if (!presetId || !list.length) return false;
    var preset = null;
    list.forEach(function (item) {
      if (item && item.id === presetId) preset = item;
    });
    if (!preset || !preset.state || !core.applyEditableState(state, preset.state)) return false;
    state.splitter = rules.splittersByBranchCount[state.installations.length] || null;
    fixtureBranchIndex = 0;
    currentStep = 4;
    return true;
  }

  applyScenePreset();
  bootstrapEditMode().then(function () {
    renderAll();
    ensurePriceCatalog();
  });
})(window);
